import { BookingObjectType } from 'src/components/BookingObjectTypeSelect/types';

export const supportsAuthor = new Set<BookingObjectType>([
  BookingObjectType.Desk,
  BookingObjectType.Parking,
]);
